import type { ReactNode } from 'react';

export interface SummaryCardProps {
  label: string;
  /** Pre-rendered value — usually a <Money/> for currency cents. */
  value: ReactNode;
  /** Optional sub-line beneath the value (e.g. "${refunds} refunded"). */
  hint?: string;
}

export function SummaryCard({ label, value, hint }: SummaryCardProps) {
  return (
    <div className="kpi card card-pad">
      <div className="label" style={{ color: 'var(--fg-3)', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.4 }}>
        {label}
      </div>
      <div className="value" style={{ fontSize: 28, fontWeight: 600, marginTop: 6 }}>
        {value}
      </div>
      {hint && (
        <div className="delta" style={{ color: 'var(--fg-4)', fontSize: 12, marginTop: 4 }}>
          {hint}
        </div>
      )}
    </div>
  );
}
